import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate";
import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(Vuex, axios, VueAxios);

export const store = new Vuex.Store({ 
    plugins: [
  createPersistedState({
    paths: [
      'redirectUrl',
      'defaultOrgId',
      'api_key'
    ]
  })
],
    state: { 
        redirectUrl: "/",
        defaultOrgId: '',
        api_key: null,
        errors: [],
        success: [],
        info: [],
        permissions: [],
    },

    mutations: {
        storeUser(state, payload) {
            state.api_key = (payload == null ? null : payload.api_token);
            if (payload == null)
                state.defaultOrgId = null
        },
        logout(state) {
    state.api_key = null
    state.defaultOrgId = null
    state.permissions = []
},

        setRedirectUrl(state, payload) {
            state.redirectUrl = payload;
        },
        refreshUser(state, payload) {
            state.user = payload;
        },
        setOrg(state, payload) {
            state.defaultOrgId = payload;
        },
        cachePermissions(state, payload) {
            state.permissions = payload;
        },
        setAlert(state, payload) {
            if (payload.type === "info")
                state.info = payload.alert;
            if (payload.type === "success")
                state.success = payload.alert;
            if (payload.type === "error")
                state.errors = payload.alert;
        }
    },

    actions: {
        setAlert({commit}, payload) {
            commit('setAlert', payload)
        },
                logout({ commit }) {
            commit('logout')
            localStorage.removeItem('vuex') // because you’re using persisted state
        },
        cachePermissions({commit}, payload) {
            commit('cachePermissions', payload)
        },
        setRedirectUrl({commit}, payload) {
            commit('setRedirectUrl', payload)
        },
        setOrg({commit}, payload) {
            commit('setOrg', payload)
        },
        login({commit}, payload) {
            commit('storeUser', payload)
        }
    },

    getters: {
        getRedirectUrl(state) {
            return state.redirectUrl
        },
        orgId(state) {
            return state.defaultOrgId
        },
        apiToken(state) {
            return state.api_key
        },
        loggedIn(state) {
            return state.api_key != null
        },
        can: (state) => (permission) => {
            return Array.isArray(permission) ? permission.some(r => state.permissions.indexOf(r) >= 0) : state.permissions.includes(permission)
        },
        info(state) {
            return state.info;
        },
        success(state) {
            return state.success;
        },
        error(state) {
            return state.errors;
        },
    }
});